import React from 'react';
import PropTypes from 'prop-types';

export default function PxValueComponent({ pxValue, pxColor, cellOperation }) {
  return (
    <div className="px-value">
      <div className="color-box">
        <div className="color" style={pxColor}>
          {parseFloat(pxValue, 10).toFixed(1)}
        </div>
      </div>
      <div className="text">{cellOperation} pX Value</div>
    </div>
  );
}

PxValueComponent.propTypes = {
  pxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  pxColor: PropTypes.object.isRequired,
  cellOperation: PropTypes.string.isRequired,
};
